import src from "IMAGE";
export default { src, width: 560, height: 72, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AGBgYFBkZGRTaGhoWFVVVUVNTU1CR0dHPE1NTUFOTk5DtU8KU0N5TlUAAAAASUVORK5CYII="};
